module.exports = __webpack_public_path__ + "img/caidaoApp-1.ed3d9b96.png";